import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./styles/rtl.scss";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store";
import { Provider } from "react-redux";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import App from "./components/App";
import { HelmetProvider } from "react-helmet-async";
import Main from "./pages/Main";
import PackageJson from "../package.json";
import { initializeGA } from "./utils/analytics";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TenantAssetsProvider } from "./contexts/TenantAssetsContext";

// @ts-ignore
globalThis.version = PackageJson.version;

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <Provider store={store}>
    <TenantAssetsProvider>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ThemeProvider theme={theme}>
          <HelmetProvider>
            <CssBaseline />
            <Main />
          </HelmetProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </TenantAssetsProvider>
  </Provider>
);

// Initialize Google Analytics after the React app is rendered
initializeGA();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
